import PhoneIcon from '../../../assets/svg/PhoneIcon';
import { DIAL_OUTCOME_SQL_LABEL } from '../../../constants';
import { WidgetCard } from '../WidgetCard';
import { DialOutcomeDetails } from './DialOutcomeDetails';
import { DownloadSentEmailDetails } from './DownloadSentEmailDetails';

const getData = ({ totals, notInterestedBreakdown, doNotCallBreakdown }) => [
  { label: 'Callback', value: totals.callback },
  { label: DIAL_OUTCOME_SQL_LABEL, value: totals.email },
  {
    label: 'Not Interested',
    value: totals.notInterested,
    options: [
      { label: 'No budget', value: notInterestedBreakdown.noBudget },
      {
        label: 'Uses competitor',
        value: notInterestedBreakdown.usesCompetitor,
      },
      { label: 'Not a good time', value: notInterestedBreakdown.notAGoodTime },
      {
        label: 'No need for our service',
        value: notInterestedBreakdown.noNeedForOurService,
      },
    ],
  },
  { label: 'No Answer', value: totals.noAnswer },
  { label: 'Hung Up', value: totals.hangUp },
  {
    label: 'Do Not Call',
    value: totals.doNotCall,
    options: [
      { label: 'Wrong Contact', value: doNotCallBreakdown.wrongContact },
      { label: 'Wrong Number', value: doNotCallBreakdown.wrongNumber },
      { label: 'Bad Number', value: doNotCallBreakdown.badNumber },
      {
        label: 'Company not in business',
        value: doNotCallBreakdown.companyNotInBusiness,
      },
      {
        label: 'No Longer with Company',
        value: doNotCallBreakdown.noLongerWithCompany,
      },
      { label: 'Retired', value: doNotCallBreakdown.retired },
      { label: 'Remove from List', value: doNotCallBreakdown.removeFromList },
      {
        label: 'Unsuitable company',
        value: doNotCallBreakdown.unsuitableCompany,
      },
      { label: 'Current customer', value: doNotCallBreakdown.currentCustomer },
    ],
  },
];

export const ChartDialOutcomes = ({
  data,
  filters,
  isActionsVisible = true,
}) => {
  return (
    <WidgetCard title="Dial Outcomes" Icon={PhoneIcon}>
      <div className="grid grid-rows-2 grid-cols-3 gap-5 pt-5 pb-2">
        {getData(data).map((v, idx) => {
          const isActionsAvailable = v.value !== 0 && isActionsVisible;
          const isDialOutcomeDetailsVisible = !!v.options;

          // TODO: remove once contactService.getContactDataByLeadIds handles
          // null startDate/endDate — it currently throws a DATABASE SQL error for them.
          const isLifetimeFilterActive = !filters.startDate;
          const isDownloadSentEmailDetailsVisible =
            v.label === DIAL_OUTCOME_SQL_LABEL && !isLifetimeFilterActive;

          return (
            <div key={idx} className="flex flex-col gap-1">
              <span className="text-[14px]/[20px] font-medium text-base-800">
                {v.label}
              </span>
              <div className="flex items-center gap-1.5">
                <span className="text-[22px]/[28px] font-semibold text-base-1000 truncate">
                  {v.value}
                </span>
                {isActionsAvailable && (
                  <>
                    {isDialOutcomeDetailsVisible && (
                      <DialOutcomeDetails {...v} />
                    )}
                    {isDownloadSentEmailDetailsVisible && (
                      <DownloadSentEmailDetails filters={filters} />
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </WidgetCard>
  );
};
